import React, { useEffect } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import Float from "../ui/Float";
import { useTabs } from "../hooks/useTabs";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import DateField from "../ui/DateField";
import FocusWrap from "../hooks/FocusWrap";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import DateInput from "../ui/DateInput";
import { addISBNDashes, arrayToObject, copyToClipboard } from "../utils/Utils";
import { VALIDATE } from "../utils/Validators";
import { ORDER } from "../utils/Struct";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";

export default function OrdersDetails(props) {
    const {
        controller = "",
        route = "",
        selected = {},
        setSelected = () => { },
        items = [],
        setItems = () => { },
        selectedItem = {},
        setSelectedItem = () => { },
        callback = () => { },
        state = {},
        editISBN = () => { }
    } = props;

    const {
        cancel_date = 0,
        clerk_code = "",
        condition_code = "",
        customer = null,
        customer_po = "",
        default_supplier = false,
        invoice = "",
        invoice_date = 0,
        invoice_price = "",
        is_single_title_order = false,
        ms_split = [],
        note = [],
        order_id = "",
        order_number = "",
        order_separator = "",
        po_number = "",
        prepay_issue_id = null,
        primary_code = "",
        quantity = "",
        req_date = "",
        review_days = "",
        status = "",
        status_date = 0,
        supplier = "",
        supplier_country = "",
        supplier_currency = "",
        supplier_discount = "",
        supplier_name = "",
    } = selected || {};


    const {
        shop = "",
        ship_to = "",
        name = ""
    } = customer || {};

    const edit = state?.edit;

    const defaultTabs = [
        { key: "status", value: status, skip: false },
        { key: "status_date", value: status_date, skip: false },
        { key: "cancel_date", value: cancel_date, skip: false },

        { key: "quantity", value: quantity, skip: false },
        { key: "primary_code", value: primary_code, skip: false },
        { key: "condition_code", value: condition_code, skip: false },

        // not in provided data, but keeping fields ready
        { key: "title", value: selected?.title || "", skip: true },

        { key: "supplier", value: supplier, skip: false },
        { key: "supplier_name", value: supplier_name, skip: false },

        { key: "invoice_price", value: invoice_price, skip: false },
        { key: "supplier_discount", value: supplier_discount, skip: false },

        // not in provided data, but keeping fields ready
        { key: "sell_price", value: selected?.sell_price || "", skip: false },
        { key: "pm", value: selected?.pm || "", skip: false },

        { key: "order_number", value: order_number, skip: false },
        { key: "invoice", value: invoice, skip: false },
        { key: "invoice_date", value: invoice_date, skip: false },

        { key: "clerk_code", value: clerk_code, skip: false },
        // { key: "condition_code", value: condition_code, skip: false },

        { key: "customer", value: customer?.name || selected?.customer_name || "", skip: false },
        { key: "customer_notify", value: customer?.notify, skip: false },
        { key: "phone", value: customer?.phone || selected?.phone || "", skip: true },
        { key: "customer_po", value: customer_po, skip: false },
        { key: "po_number", value: po_number, skip: false },

        // { key: "note", value: Array.isArray(note) ? note.join("\n") : note || "", skip: false },
    ];

    const statuses = {
        status: "Present state of this order. <PgUp> to select a status",
        status_date: "Date the status was applied",
        cancel_date: "Cancel Date: Date the supplier must ship by (filled when order sent)",

        quantity: "Edit: Change an existing order",
        primary_code: "ISBN / Primary Code",
        title: "Title",

        supplier: "Supplier Code",
        supplier_name: "Supplier Name",

        invoice_price: "Invoice Price",
        supplier_discount: "Supplier Discount",

        sell_price: "Selling Price",
        pm: "Profit Margin",

        order_number: "Order Number",
        invoice: "Invoice Number",
        invoice_date: "Invoice Date",

        clerk_code: "Clerk Code",
        condition_code: "Condition Code",

        customer: "Enter name, phone or acct# <PgUp> to view acct.",
        customer_notify: "Notify customer via: [PgUp]",
        phone: "Phone",
        customer_po: "Customer PO Number",
        po_number: "PO Number",

        note: "Note",
    };

    const {
        tabs,
        setTabs,
        index,
        setIndex,
        update,
        getVal,
        editProps,
        next,
        prev,
        refs,
    } = useTabs(defaultTabs, "status");

    useEffect(() => {
        setTabs(defaultTabs);
    }, [selected]);


    const cancelEdit = () => {
        setTabs(defaultTabs);
        callback(false);
    };


    const saveEdit = (_update = tabs) => {
        
        console.log(selected)
        let _api = "order.editItem";

        if(!selected?.order_id){
            _api = "order.addItem";
        }
        
        _update = arrayToObject(_update);

        _update.customer = null; 

        const _ret = {...selected, ..._update}; 
    
        
        pubCall(_api, {order_item : _ret, require_clerk_code : true}, (_s, _r) => {
            if(_s){
                console.log(_r);
            } else {
                showError(_r);
            }
        })

    }


    useEffect(() => {
        if (refs?.current?.[index]) {
            refs.current[index].focus();
        }

        const actions = [
            { key: KBD.ESCAPE, action: () => cancelEdit(false) },
            { key: KBD.PAGE_DOWN, action: () => saveEdit() },
            { key: KBD.ARROW_DOWN, action: () => next() },
            { key: KBD.ARROW_UP, action: () => prev() },
        ];

        const cleanup = listen(
            controller,
            route,
            actions,
            false,
            [
                KBD.ARROW_DOWN,
                KBD.ARROW_UP,
                KBD.PAGE_UP,
                KBD.PAGE_DOWN,
                KBD.ALT_S,
                KBD.ALT_H,
                KBD.ESCAPE,
            ]
        );

        return cleanup;
    }, [index, controller, route]);

    const label_width = 37;



    return (
        <FocusWrap message={<Status type="active"><InfoIcon />{statuses?.[index] || ""}</Status>} style={{ "height": "auto" }} active={edit}>
            <div className="pos-card" style={{ height: "260px", overflow: "hidden" }}>
                <div className="shim" />

                <div style={{ display: "flex", gap: "20px" }}>
                    <div style={{ flex: "1" }}>
                        <Float>
                            <Space>
                                <Label width={label_width}>Stat</Label>
                                <Input
                                    maxLength={4}
                                    {...editProps("status")}
                                    width={80}
                                    value={getVal("status")}
                                    edit={edit}
                                />
                            </Space>

                            <Space>
                                <DateInput
                                    {...editProps("status_date")}
                                    width={100}
                                    timestamp
                                    value={getVal("status_date")}
                                    edit={edit}
                                    onChange={(e) => {

                                    }}
                                />

                                <Label >Cancel date</Label>

                                <DateInput
                                    timestamp
                                    {...editProps("cancel_date")}
                                    width={100}
                                    value={getVal("cancel_date")}
                                    edit={edit}
                                />
                            </Space>
                        </Float>

                        <div className="shim" />

                        <Space>
                            <Label width={label_width}>Qty</Label>
                            <Input
                                {...editProps("quantity")}
                                width={35}
                                number
                                maxLength={3}
                                value={getVal("quantity")}
                                right
                                edit={edit}
                            />
                        </Space>

                        <div className="shim" />

                        <Space>
                            <Label width={label_width}>ISBN</Label>
                            <Space size={4}>
                                <Input remember="primary_code" onPageUp={(e, f) => {
                                    f.preventDefault();
                                    f.stopPropagation();
                                    editISBN(e, getVal("condition_code") || "")
                                }} onCopy={() => { copyToClipboard(addISBNDashes(getVal("primary_code"), condition_code, false)) }} grow maxLength={15} validator={VALIDATE.EMPTY} {...editProps("primary_code")} width={175} edit={edit} />
                                <Input remember="condition_code" uppercase maxLength={1} doubleclick={KBD.PAGE_UP} {...editProps("condition_code")} width={20} value={condition_code} edit={edit} />
                            </Space>
                        </Space>

                        <div className="shim" />

                        <Space>
                            <Label width={label_width}>Title</Label>
                            <Input
                                {...editProps("title")}
                                width={400}
                                value={getVal("title")}
                                edit={edit}
                            />
                        </Space>

                        <div className="shim" />

                        <Space>
                            <Label width={label_width}>Supl</Label>
                            <Input
                                {...editProps("supplier")}
                                width={60}
                                value={getVal("supplier")}
                                edit={edit}
                            />

                            <Input
                                {...editProps("supplier_name")}
                                width={324}
                                value={getVal("supplier_name")}
                                edit={edit}
                            />
                        </Space>

                        <div className="shim" />

                        <Space>
                            <Label width={label_width}>
                                <nobr>InvPr</nobr>
                            </Label>

                            <Input
                                {...editProps("invoice_price")}
                                width={80}
                                value={getVal("invoice_price")}
                                right
                                edit={edit}
                            />

                            <Input
                                {...editProps("supplier_discount")}
                                width={35}
                                value={getVal("supplier_discount")}
                                right
                                edit={edit}
                            />

                            <Label>%</Label>
                        </Space>

                        <div className="shim" />

                        <Space>
                            <Label width={label_width}>
                                <nobr>Sell</nobr>
                            </Label>

                            <Input
                                {...editProps("sell_price")}
                                width={80}
                                value={getVal("sell_price")}
                                right
                                edit={edit}
                            />

                            <Input
                                {...editProps("pm")}
                                width={35}
                                value={getVal("pm")}
                                right
                                edit={edit}
                            />

                            <Label>PM</Label>
                        </Space>

                        <div className="shim" />

                        <Space>
                            <Label width={label_width}>
                                <nobr>Order</nobr>
                            </Label>

                            <Input
                                {...editProps("order_number")}
                                width={80}
                                value={getVal("order_number")}
                                edit={edit}
                            />
                        </Space>

                        <div className="shim" />

                        <Space>
                            <Label width={label_width}>
                                <nobr>Inv #</nobr>
                            </Label>

                            <Input
                                {...editProps("invoice")}
                                width={140}
                                value={getVal("invoice")}
                                edit={edit}
                            />

                            <Label width={label_width}>
                                <nobr>Date</nobr>
                            </Label>

                            <DateInput
                                {...editProps("invoice_date")}
                                width={100}
                                value={getVal("invoice_date")}
                                edit={edit}
                            />
                        </Space>
                    </div>

                    <div style={{ flex: "1" }}>
                        <Float>
                            <div>&nbsp;</div>

                            <Space>
                                <Label width={39}>Acct</Label>

                                <Input
                                    {...editProps("clerk_code")}
                                    width={100}
                                    value={getVal("clerk_code")}
                                    edit={edit}
                                />

                                <Input
                                    // {...editProps("condition_code")}
                                    width={20}
                                    // value={getVal("condition_code")}
                                    edit={false}
                                />
                            </Space>
                        </Float>

                        <div className="shim" />

                        <Space>
                            <Label width={80}>Customer</Label>
                            <Input
                                {...editProps("customer")}
                                width={260}
                                value={getVal("customer")}
                                edit={edit}
                            />
                        </Space>

                        <div className="shim" />

                        <Space>
                            <Label width={80}>Phone</Label>
                            <Input
                                width={260}
                                value={getVal("phone")}
                                edit={false}
                            />
                        </Space>

                        <div className="shim" />

                        <Space>
                            <Label width={80}>Cust PO#</Label>
                            <Input
                                {...editProps("customer_po")}
                                width={130}
                                value={getVal("customer_po")}
                                edit={edit}
                            />
                        </Space>

                        <div className="shim" />
                        <div className="shim" />

                        <Divider />

                        <div className="shim" />
                        <div className="shim" />

                        <Space>
                            <Label width={80}>PO#</Label>
                            <Input
                                {...editProps("po_number")}
                                width={130}
                                value={getVal("po_number")}
                                edit={edit}
                            />
                        </Space>

                        <div className="shim" />

                        <Space>
                            <Label width={80}>Note</Label>
                            <Input
                                {...editProps("note")}
                                width={260}
                                value={getVal("note")}
                                edit={edit}
                            />
                        </Space>
                    </div>
                </div>
            </div>
        </FocusWrap>
    );
}